import { render, staticRenderFns } from "./tracking-domains.vue?vue&type=template&id=db2a7a6e&"
import script from "./tracking-domains.ts?vue&type=script&lang=js&"
export * from "./tracking-domains.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports